import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (token) {
    return <Navigate replace to="/user" state={{ from: location }} />;
  }
  return <Outlet />;
};
export default PublicRoute;
